// extracted by mini-css-extract-plugin
export default {"nav-link":"styles_nav-link__05hBY","active":"styles_active__MoFCN","nav-tabs":"styles_nav-tabs__DIToi","nav":"styles_nav__fV6L1"};